// Soft-launch nav gating: an entry is only shown when its env var is
// explicitly "true". A build without these keys hides them — that is the
// intended fail-safe, the routes themselves stay reachable by URL.
const on = (value) => String(value).toLowerCase() === "true";

const navFlags = {
  tournaments: on(process.env.REACT_APP_NAV_TOURNAMENTS_ENABLED),
  missions: on(process.env.REACT_APP_NAV_MISSIONS_ENABLED),
  rewards: on(process.env.REACT_APP_NAV_REWARDS_ENABLED),
  store: on(process.env.REACT_APP_NAV_STORE_ENABLED),
  wheel: on(process.env.REACT_APP_NAV_WHEEL_ENABLED),
};

export default navFlags;
